export function OutlineCommentsIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 4.9968V10.0032C15 11.1072 14.1072 12 13.0032 12H9L4.9968 15V12C3.8976 12 3 11.1072 3 10.0032V4.9968C3 3.8928 3.8976 3 4.9968 3H13.0032C14.1072 3 15 3.8928 15 4.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0048 10.9968V16.0032C21.0048 17.1072 20.1072 18 19.008 18V21L15.0048 18H10.9968C9.8928 18 9 17.1072 9 16.0032V12H13.0032C14.1072 12 15 11.1072 15 10.0032V9H19.008C20.1072 9 21.0048 9.8928 21.0048 10.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
